<template>
  <div class="side-panel side-panel-left subnav active" ref="scrollContainer">
    <div class="side-panel-header top-sticky-blur top-sticky-blur-neutral d-none-pseudo px-0 pb-0 pt-4" >
      <!--:style="{ height: avatarSize + 'px', width: headerWidth + 'px' }"-->
      <user-avatar
        :value="photoUrl"
        editable
        :scroll="scrollTop"
        size="xl"
        variant="default"
        url="/settings/photo"
        name="photo"
        @upload="$store.dispatch('auth/fetchUser')" />
      <div class="account-settings-meta">
        <h3 :style="{ fontSize: titleSize + 'px'}" class="txt-bold mt-2 mb-0 ph-no-capture">{{ user.name }}</h3>
        <p :style="{ fontSize: emailSize + 'px'}" class="txt-body txt-muted ph-no-capture">{{ user.email }}</p>
        <p class="txt-body txt-bold txt-muted" :style="{opacity: labelOpacity, maxHeight: labelHeight + 'px'}">{{ currentPlanLabel }}</p>
      </div>
      <hr class="mb-0 mt-3" :style="{opacity: 1 - labelOpacity}"/>
    </div>
    <div class="side-panel-body pb-4">
      <template v-for="group in childRoutes">
        <h4 class="txt-muted txt-body ml-1 p-2 mt-4">{{ group.title }}</h4>

        <template v-for="(r, index) in group.routes">
          <div :key="r.label + '-subnav'" :id="r.label + '-subnav-item'">
            <router-link
              :to="r.locked ? {} : (r.route ? {name: r.route} : {})"
              :custom="!!r.onClick"
              v-slot="{ navigate, isActive }"
              :class="{'disabled-link': r.locked}"
            >
              <a @click.stop="r.locked ? false : r.onClick ? r.onClick($event) : navigate($event)" 
                 role="link" 
                 class="subnav-item" 
                 :class="{'subnav-item-active': (isActive || (r.route === 'AccountSubscription' && $route.path.includes('/settings/subscription'))) && !r.onClick && !r.locked, 'subnav-item-disabled': r.locked}" 
                 :aria-disabled="r.locked"
                 :tabindex="r.locked ? -1 : 0"
              >
                <svg v-if="r.icon" width="24" viewBox="0 0 24 24" class="icon-regular nav-icon">
                  <use :xlink:href="`#icon-${r.icon}`"></use>
                </svg>
                <span class="name">{{ r.label }}</span>
                
                <template v-if="r.locked">
                  <svg v-if="!(r.route === 'AccountWebhooks' && $cant('webhooks') || r.route === 'AccountTeam' && !hasTeams)" width="24" viewBox="0 0 24 24" class="icon-regular txt-muted ml-2">
                      <use xlink:href="#icon-lock"></use>
                  </svg>
                  <upgrade-button v-if="(r.route === 'AccountWebhooks' && $cant('webhooks') || r.route === 'AccountTeam' && !hasTeams)" class="ml-auto" />
                </template>
                <svg v-if="r.warning" class="ml-auto" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.1414 9.89226C10.75 8.82724 11.0543 8.29472 11.4526 8.11654C11.7999 7.96115 12.1971 7.96115 12.5444 8.11654C12.9427 8.29472 13.247 8.82724 13.8556 9.89226L15.5171 12.7999C16.1176 13.8508 16.4178 14.3762 16.3712 14.8071C16.3305 15.1829 16.1326 15.5239 15.8265 15.7457C15.4755 16 14.8704 16 13.66 16H10.337C9.12665 16 8.52148 16 8.17054 15.7457C7.86441 15.5239 7.6665 15.1829 7.62581 14.8071C7.57917 14.3762 7.87942 13.8508 8.47991 12.7999L10.1414 9.89226Z" fill="#DC931D"/>
                </svg>
              </a>
            </router-link>
            <!--
            <b-tooltip v-if="r.locked && !!r.tooltipAction" custom-class="tooltip-no-wrap" variant="ss" :target="r.label + '-subnav-item'" triggers="hover" boundary="viewport">
                <button class="tooltip-cta txt-white" @click="r.tooltipAction">
                  <span class="tooltip-cta-inner">{{ r.tooltip }}</span>
                  <span class="btn-icon ml-2 p-0">
                      <svg class="icon-regular" viewBox="0 0 24 24"><use xlink:href="#icon-chevron-right"></use></svg>
                    </span>
                </button>
            </b-tooltip>
            -->
            <b-tooltip v-if="r.locked && !r.tooltipAction" custom-class="tooltip-no-wrap" variant="ss" :target="r.label + '-subnav-item'" triggers="hover" boundary="viewport">
                 <span v-if="r.locked && r.route === 'AccountTeam' && isMember">{{ r.tooltip }}</span>
                 <span v-else-if="r.locked && r.route !== 'AccountWebhooks' && r.route !== 'AccountTeam'">{{ r.tooltip ? r.tooltip : 'Coming soon' }}</span>
            </b-tooltip>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
  import get from 'lodash/get';
  import UserAvatar from "@app2/core/Components/UserAvatar";
  import subscriptionMixin from "@app2/modules/AccountSettings/Pages/Routes/Subscription/Helpers/subscription.mixin.js";
  import UpgradeButton from '@app2/core/Components/UpgradeButton.vue';
  import _debounce from 'lodash/debounce';

  export default {
    name: 'HubSettingsSidenav',
    mixins: [subscriptionMixin],
    components: {
      UserAvatar,
      UpgradeButton,
    },
    data() {
      return {
        scrollTop: 0,
      }
    },
    computed: {
      user() {
        return this.$store.getters['auth/GET_USER'];
      },
      photoUrl() {
        return get(this.user, 'photo_url');
      },
      titleSize() {
        return Math.round(27 - this.scrollTop * 0.0463);
      },
      emailSize() {
        return 14 - this.scrollTop * 0.0277;
      },
      labelOpacity() {
        return 1 - this.scrollTop * 0.025;
      },
      labelHeight() {
        return 23 - this.scrollTop * 0.213;
      },
      hasPaymentWarning() {
        const status = store.getters['auth/GET_PAYMENT_SOURCE']?.status;
        return status && status !== 'valid';
      },
      childRoutes() {
        let routes = [
          {
            title: 'Account',
            routes: [
              {
                label: 'Profile',
                description: 'Manage account info.',
                icon: 'user-single',
                route: 'AccountProfile',
              },
              {
                label: 'Team',
                description: 'Manage your teammates and invite new ones.',
                icon: 'user-multiple-2',
                route: 'AccountTeam',
                locked: this.isMember || !this.hasTeams,
                tooltip: this.isMember ? 'You do not have access to team settings.' : false,
              },
              {
                label: 'Security',
                description: 'Change password.',
                icon: 'lock-tick',
                route: 'AccountSecurity',
              },
              {
                label: 'Data',
                description: 'Manage account data.',
                icon: 'user-data',
                route: 'AccountData',
              },
            ],
          },
          {
            title: 'Billing',
            routes: [
              {
                label: 'Subscription',
                description: 'Update your subscription.',
                icon: 'money',
                route: 'AccountSubscription',
                locked: this.isMember,
                tooltip: this.isMember ? 'You do not have access to billing settings.' : false
              },
              {
                label: 'Payments',
                description: 'Update your payment details.',
                icon: 'credit-card-single',
                route: 'AccountPayments',
                locked: this.isMember || this.isUsingSparkAdapter,
                tooltip: this.isMember ? 'You do not have access to payment settings.' : this.isUsingSparkAdapter ? 'We are moving to a new billing system in order to serve you better. Please contact support at help@membership.io to make changes to your current subscription. Changes to your subscription may take up to 3 business days to process at this time. Thanks for your patience.' : false,
                warning: this.hasPaymentWarning
              },
              {
                label: 'Invoices',
                description: 'View and download your invoice history.',
                icon: 'page-multiple',
                route: 'AccountInvoices',
                locked: this.isMember,
                tooltip: this.isMember ? 'You do not have access to invoice settings.' : false
              },
            ]
          },
          {
            title: 'Content',
            routes: [
              {
                label: 'Transcripts',
                description: 'Set a default language and build your custom vocabulary.',
                icon: 'transcriptions',
                route: 'AccountTranscripts',
              },
              {
                label: 'Player',
                description: 'Configure the look and feel of your media player.',
                icon: 'video-player',
                route: 'AccountPlayer',
              },
            ]
          },
        ]
        routes.push({
          title: 'Developers',
          routes: [
            {
              label: 'Webhooks',
              description: 'Configure endpoints to be notified about events in your Membership.io account.',
              icon: 'unplug',
              route: 'AccountWebhooks',
              locked: this.$cant('webhooks'),
              tooltip: false,
            },
          ]
        });
        return routes;
      },
      isMember() {
        return this.$store.getters['auth/GET_TEAMS'].find(t => t.id === this.$store.state.auth.user.current_team_id)?.role === 'member';
      },
      hasTeams() {
        return get(this.user, 'chargebee_permissions.team-accounts.quota', 0) > 0 || get(this.user, 'chargebee_permissions.team-accounts.quota', 0) === 'Unlimited';
      }
    },
    methods: {
      handleScroll(event) {
        if(event.target.scrollTop < 108) {
          this.scrollTop = event.target.scrollTop;
        } else {
          this.scrollTop = 108;
        }
      }
    },
    mounted() {
      // Access the scroll container element using the ref
      const scrollContainer = this.$refs.scrollContainer;

      // Debounce the handleScroll method
      const debouncedScrollHandler = _debounce(this.handleScroll, 10);

      // Add scroll event listener to the scroll container
      scrollContainer.addEventListener('scroll', debouncedScrollHandler);
    },
    beforeDestroy() {
      // Access the scroll container element using the ref
      const scrollContainer = this.$refs.scrollContainer;

      // Remove the scroll event listener before component is destroyed
      scrollContainer.removeEventListener('scroll', this.handleScroll);
    },
  }
</script>
